//libraries

import "../css/Website.scss";

//Components
// import Icon from "components/Icons/Icon";
import Footer from "../components/Footer";
import LanguageSwitcher from "../components/LanguageSwitcher";

import Navigation from "../components/navigation/Navigation";
import OutroCTA from "../components/OutroCTA";
import { t } from "i18n/index";

interface AboutProps {
  lang?: string;
  uiTranslations?: Record<string, string>;
}

const About = ({ uiTranslations = {} }: AboutProps) => {
  return (
    <div id="stippl-about">
      <Navigation impact={false} langMenu={<LanguageSwitcher type="page" />} />

      <div className="container__full-width">
        <section className="about-header"></section>
        <section className="team">
          <div className="container__inner">
            <div className="team__content">
              <h1>{t(uiTranslations, "about.heading", "Our mission is to make travel planning almost as enjoyable as traveling itself.")}</h1>
              <p>
                {t(
                  uiTranslations,
                  "about.body1",
                  "We founded Stippl out of a shared frustration with the tedious and time-consuming process of travel planning. As avid travelers and experienced product builders, we knew there had to be a better way. We wanted to create a platform that seamlessly integrates every aspect of travel planning - from finding transportation to discovering the perfect accommodation - all while providing a beautiful, user-friendly, and easily shareable experience."
                )}
              </p>
              <p>
                {t(
                  uiTranslations,
                  "about.body2Pre",
                  "Our mission is to make the process of planning a trip as enjoyable as the journey itself. Join us on this mission by creating an account now and let us know what you think. Your feedback is invaluable to us as we continue to improve and evolve Stippl. Don’t hesitate to reach out to us at"
                )}{" "}
                <a href="mailto:info@stippl.io">info@stippl.io</a>
                {t(uiTranslations, "about.body2Post", "!")}
              </p>
            </div>
          </div>
        </section>
      </div>
      <OutroCTA />
      <Footer />
    </div>
  );
};

export default About;
